export const groupArrayByField = <T>(
  arr: T[],
  fieldname: Extract<keyof T, string>
): T[][] => {
  const result = arr
    .sort((a, b) => (a[fieldname] < b[fieldname] ? -1 : +1))
    .reduce((c: any, a: any) => {
      const firstLetter = a[fieldname][0] as string;
      c[firstLetter] = c[firstLetter] || [];
      c[firstLetter].push(a);
      return c;
    }, Object.create(null));
  return Object.values(result);
};
